import { FC } from 'react';
import MUIDialog, { DialogProps } from '@mui/material/Dialog';

// Focus management is intentional: when a dialog opens, focus moves into it
// (FocusTrap), and on close it returns to the trigger element (restoreFocus).
// The shared wrapper makes these defaults explicit so callers can still override
// per dialog, but the focus-in / focus-out contract is documented in code.
const Dialog: FC<DialogProps> = ({
    disableEnforceFocus = false,
    disableAutoFocus = false,
    disableRestoreFocus = false,
    ...other
}) => (
    <MUIDialog
        disableEnforceFocus={disableEnforceFocus}
        disableAutoFocus={disableAutoFocus}
        disableRestoreFocus={disableRestoreFocus}
        {...other}
    />
);

export default Dialog;
